import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import clsx from 'clsx';

import { COLORS, ids, modalMessages } from 'apps/web_forms/utils/constants';
import ErrorMessage from 'apps/web_forms/components/commons/ErrorMessage';
import Modal from 'apps/web_forms/components/commons/Modal';

const StyledDiv = styled.div`
  font-weight: 400;
  font-family: 'Helvetica', 'Roboto';
  width: 100%;

  .invalid {
    border: 2px solid ${COLORS.red};
    outline: none;
  }
`;

const StyledTextArea = styled.textarea`
  font-weight: 400;
  font-family: 'Helvetica', 'Roboto';
  border: 1px solid #dddddd;
  background-color: #f8f8f8;
  width: 100%;
  padding: 0.5em;
  resize: none;
`;

const SaveDraftModal = ({
  draftDescriptionInputValue,
  setDraftDescriptionInputValue,
  draftModalOpen,
  setDraftModalOpen,
  mainMessage,
  helpTip,
  saveButtonText,
  onSave,
}) => {
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    if (draftDescriptionInputValue && draftDescriptionInputValue.length > 255) {
      setHasError(true);
      setErrorMessage('Draft description too long');
    } else {
      if (hasError) {
        setHasError(false);
        setErrorMessage(null);
      }
    }
  }, [draftDescriptionInputValue, hasError]);

  const close = () => {
    setDraftModalOpen(false);
  };

  return (
    <Modal
      mainMessage={mainMessage}
      helpTip={helpTip}
      isOpen={draftModalOpen}
      setIsOpen={setDraftModalOpen}
      testId={ids.SaveDraftModalIds.SaveDraftModal}
      buttons={[
        {
          id: ids.SaveDraftModalIds.CancelButton,
          label: 'Cancel',
          onClick: close,
          filled: false,
          disabled: false,
        },
        {
          id: ids.SaveDraftModalIds.SaveButton,
          label: saveButtonText,
          onClick: () => onSave(),
          filled: true,
          disabled: hasError,
        },
      ]}
    >
      <StyledDiv className='react-form-control'>
        <StyledTextArea
          rows='3'
          maxLength={255}
          value={draftDescriptionInputValue}
          onChange={(event) =>
            setDraftDescriptionInputValue(event.target.value)
          }
          className={clsx(hasError && 'invalid')}
        />
        {hasError && errorMessage && (
          <ErrorMessage id={`${ids.SaveDraftModalIds.SaveDraftModal}_errmsg`}>
            {errorMessage}
          </ErrorMessage>
        )}
      </StyledDiv>
    </Modal>
  );
};

SaveDraftModal.propTypes = {
  mainMessage: PropTypes.string,
  helpTip: PropTypes.string,
  saveButtonText: PropTypes.string,
  onSave: PropTypes.func.isRequired,
  draftDescriptionInputValue: PropTypes.string,
  setDraftDescriptionInputValue: PropTypes.func.isRequired,
  draftModalOpen: PropTypes.bool.isRequired,
  setDraftModalOpen: PropTypes.func.isRequired,
};

SaveDraftModal.defaultProps = {
  mainMessage: modalMessages.saveDraft.main,
  helpTip: modalMessages.saveDraft.tip,
  saveButtonText: 'Save',
  draftDescriptionInputValue: '',
};

export default SaveDraftModal;
